import { useFeatureFlag } from '@mews/framework';
import { FeatureFlag } from '@mews-commander/enums';
import { PaymentRequestType } from '@mews-commander/data-access';
import { EXTERNAL_PROCESS_PAYMENT_TYPES } from '../const';
import { ProcessPaymentType } from '../ProcessPaymentType';
import { useGetPaymentTypesEnabledSettingSuspense } from './useGetPaymentTypesEnabledSettingSuspense';
import { getProcessPaymentTypeCardGroupMap } from './utils';

interface GetRecordPaymentOptions {
    allowedPaymentTypes: ProcessPaymentType[];
    allowedPaymentRequestTypeOptions?: PaymentRequestType[];
}

export const useGetRecordPaymentOptionsSuspense = ({
    allowedPaymentTypes,
    allowedPaymentRequestTypeOptions = [],
}: GetRecordPaymentOptions) => {
    const paymentTypesEnabledSetting = useGetPaymentTypesEnabledSettingSuspense();
    const isPaymentRequestCollectTypeEnabled = useFeatureFlag(FeatureFlag.paymentRequestCollectTypeEnabled);
    const processPaymentTypeCardGroupMap = getProcessPaymentTypeCardGroupMap(
        allowedPaymentRequestTypeOptions,
        isPaymentRequestCollectTypeEnabled
    );

    return allowedPaymentTypes
        .filter(
            (paymentType) =>
                EXTERNAL_PROCESS_PAYMENT_TYPES.includes(paymentType) && paymentTypesEnabledSetting[paymentType]
        )
        .map((paymentType) => processPaymentTypeCardGroupMap[paymentType]);
};
